
import React, { useState } from 'react';
import './TrainerSearch.css';

const trainers = [
  {
    id: 1,
    name: "Alex Trainer",
    specialties: ["Strength", "HIIT", "Mobility"],
    bio: "Certified personal trainer with 10 years experience. Passionate about helping clients reach their goals.",
    rating: 4.9,
    location: "New York, NY",
    avatar: "A",
  },
  {
    id: 2,
    name: "Chris Lee",
    specialties: ["Yoga", "Pilates", "Flexibility"],
    bio: "Yoga and pilates instructor focused on holistic wellness and flexibility.",
    rating: 4.7,
    location: "San Francisco, CA",
    avatar: "C",
  },
  {
    id: 3,
    name: "Taylor Smith",
    specialties: ["Cardio", "Endurance", "Weight Loss"],
    bio: "Helping clients lose weight and build endurance through fun, energetic sessions.",
    rating: 4.8,
    location: "Chicago, IL",
    avatar: "T",
  },
  {
    id: 4,
    name: "Morgan Patel",
    specialties: ["Rehab", "Seniors", "Mobility"],
    bio: "Specialist in rehabilitation and senior fitness. Personalized, gentle approach.",
    rating: 4.6,
    location: "Austin, TX",
    avatar: "M",
  },
];

function TrainerSearch() {
  const [search, setSearch] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('');
  const specialties = Array.from(new Set(trainers.flatMap(t => t.specialties)));

  const filtered = trainers.filter(trainer =>
    trainer.name.toLowerCase().includes(search.toLowerCase()) &&
    (selectedSpecialty === '' || trainer.specialties.includes(selectedSpecialty))
  );

  return (
    <div className="trainer-search-dashboard">
      <div className="trainer-search-header">
        <h2>Find a Trainer</h2>


        <div className="trainer-search-controls">
          <input
            type="text"
            placeholder="Search by name..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="trainer-search-input"
          />
          <select
            value={selectedSpecialty}
            onChange={e => setSelectedSpecialty(e.target.value)}
            className="trainer-search-select"
          >
            <option value="">All Specialties</option>
            {specialties.map(spec => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="trainer-search-blurb-container fogged-card">

        {/* Add a blurb about how you can choose to make your bio public to appear here  */}
        <div className="trainer-search-blurb">

          Trainers can elect to make their bio public, allowing potential clients to learn more about their expertise and approach.
          </div>
          
          <div className="trainer-search-blurb">

          Browse our certified trainers to find the perfect match for your fitness journey. 
          </div>
          
          <div className="trainer-search-blurb">

          You can filter by name or specialty to find trainers that suit your needs.
        </div>
      </div>


      <div className="trainer-list">
        {filtered.length === 0 && (
          <div className="no-trainers">No trainers found.</div>
        )}

{/* onClick={() => window.location.href = `/trainer/${trainer.id}`} */}
        {filtered.map(trainer => (
          <div key={trainer.id} 
          style={{ cursor: 'pointer' }}
          onClick={() => window.location.href = `/profile`}
          className="trainer-card">
            <div className="trainer-avatar">{trainer.avatar}</div>
            <div className="trainer-info">
              <div className="trainer-name">{trainer.name}</div>
              <div className="trainer-specialties">
                {trainer.specialties.map(s => (
                  <span key={s} className="trainer-specialty">{s}</span>
                ))}
              </div>
              <div className="trainer-bio">{trainer.bio}</div>
              <div className="trainer-meta">
                <span className="trainer-rating">⭐ {trainer.rating}</span>
                <span className="trainer-location">{trainer.location}</span>
              </div>
            </div>
            <button className="trainer-contact-btn">More...</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TrainerSearch;